"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenu = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_api_2 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const menu_1 = require("../../components/menu/menu");
const menu_item_1 = require("../../components/menu/menu.item");
const mithril_component_1 = require("../../components/mithril.component");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const long_running_task_manager_1 = require("../long.running.task.manager");
const ReportMaker_1 = require("../report/ReportMaker");
const export_menu_ctrl_1 = require("./export.menu.ctrl");
class ExportMenu extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        /** Legacy mode: spinner state while an export is in progress */
        this.exporting = false;
        this.menu = new menu_1.MenuComponent({
            items: () => this.viewDownloadItems(),
        });
    }
    get legacyMode() {
        return !index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_NEW_EXPORT_UI);
    }
    get nodes() {
        if (this.exporting || !page_state_1.CurrentState.Tag.ready) {
            return spinner_1.Spinner.view();
        }
        const userProfile = index_1.Services.UserProfile.get(index_1.Services.User.current.objectId);
        if (!index_1.Services.UserProfile.canExportReports(userProfile)) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_PERMISSION,
                disabled: true,
            });
        }
        if (page_state_1.CurrentState.CollectionEdit.isDirty) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_DIRTY,
                disabled: true,
            });
        }
        if (page_state_1.CurrentState.Tag.collections.length > core_api_1.CollectionExportPolicy.MAX_LIMIT) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_LIMIT,
                titleAttrs: { limit: core_api_1.CollectionExportPolicy.MAX_LIMIT },
                disabled: true,
            });
        }
        return (0, mithril_1.m)('div', [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE,
                onclick: this.menu.show,
                id: 'export-menu',
            }),
            this.menu.view(),
        ]);
    }
    viewDownloadItems() {
        const oneCollectionSelected = page_state_1.CurrentState.Tag.collections.length === 1;
        const tagsSelected = Boolean(page_state_1.CurrentState.Tag.tags.length);
        const canReportShort = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_SHORT);
        const hasReportCompositePhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_PHOTO) ||
            index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        const hasReportCompositePhotoOnly = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_ONLY);
        const hasReportPhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_PHOTO) || index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        // This ensures that all collections have the same form revision which is required for importing excel
        const canExportImportableExcel = page_state_1.CurrentState.Tag.collections.every((collectionSummery) => collectionSummery.formRevision === page_state_1.CurrentState.Tag.collections[0].formRevision) && index_1.Services.Token.hasAll([core_api_2.IkeToken.FEATURE_IMPORT_CSV, core_api_2.IkeToken.FEATURE_IMPORT_EXCEL]);
        const run = (func) => {
            if (this.legacyMode) {
                return this.runExportLegacy(func);
            }
            return export_menu_ctrl_1.ExportMenuController.runExport(func);
        };
        const silent = this.legacyMode;
        return [
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_KML)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportKML({ silent })),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXCEL)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportExcel({ silent })),
            },
            {
                visible: canExportImportableExcel,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.IMPORTABLE_EXCEL)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportImportableExcel({ silent })),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_JSON)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportJSON({ silent })),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT)),
                action: () => this.legacyMode
                    ? this.legacyExportPDF(ReportMaker_1.ReportTypeEnum.ReportType, i18n_1.T.EXPORT_REPORT)
                    : export_menu_ctrl_1.ExportMenuController.runExport(() => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportType, i18n_1.T.EXPORT_REPORT)),
            },
            {
                visible: tagsSelected && canReportShort,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_SHORT)),
                action: () => this.legacyMode
                    ? this.legacyExportPDF(ReportMaker_1.ReportTypeEnum.ReportShortType, i18n_1.T.EXPORT_REPORT_SHORT)
                    : export_menu_ctrl_1.ExportMenuController.runExport(() => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportShortType, i18n_1.T.EXPORT_REPORT_SHORT)),
            },
            {
                visible: tagsSelected && hasReportCompositePhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)),
                action: () => this.legacyMode
                    ? this.legacyExportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)
                    : export_menu_ctrl_1.ExportMenuController.runExport(() => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)),
            },
            {
                visible: tagsSelected && hasReportCompositePhotoOnly,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)),
                action: () => this.legacyMode
                    ? this.legacyExportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoOnlyType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)
                    : export_menu_ctrl_1.ExportMenuController.runExport(() => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoOnlyType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)),
            },
            {
                visible: tagsSelected && hasReportPhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_PHOTO)),
                action: () => this.legacyMode
                    ? this.legacyExportPDF(ReportMaker_1.ReportTypeEnum.ReportPhotoType, i18n_1.T.EXPORT_REPORT_PHOTO)
                    : export_menu_ctrl_1.ExportMenuController.runExport(() => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportPhotoType, i18n_1.T.EXPORT_REPORT_PHOTO)),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasOCalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_O_CALC)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportOCalc({ silent })),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(false, { silent })),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC_NO_PHOTO)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(true, { silent })),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasPoleforeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_POLEFOREMAN)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportPoleforeman({ silent })),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasIkePoleForeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IKE_POLEFOREMAN)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportIkePoleForeman({ silent })),
                id: 'export-ipf',
            },
            {
                visible: oneCollectionSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IMAGE_ZIP)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportImageZip({ silent })),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasDDS(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_DDS)),
                action: () => run(() => export_menu_ctrl_1.ExportMenuController.exportDDS({ silent })),
            },
        ];
    }
    // ── New export UI: PDF via download manager ──
    exportPDF(type, reportNameTranslationKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const taskManager = (0, long_running_task_manager_1.getLongRunningTaskManager)();
            const jobName = export_menu_ctrl_1.ExportMenuController.getExportLabel();
            const exportTypeLabel = (0, i18n_1.Translate)(reportNameTranslationKey);
            const taskId = taskManager.service.addFastExportTask(exportTypeLabel, jobName);
            try {
                const result = yield index_1.Services.Department.rest.Department.User.isLicensed(null);
                if (!result.results) {
                    index_1.Services.License.hasNoLicense = true;
                    taskManager.service.failFastExportTask(taskId, undefined, 'License check failed');
                    return;
                }
                const pdf = yield export_menu_ctrl_1.ExportMenuController.exportReport(type);
                const fileName = `${(0, i18n_1.Translate)(reportNameTranslationKey)} ${new Date().toDateString()}.pdf`;
                const blob = yield new Promise((resolve, reject) => {
                    try {
                        pdf.getBlob((b) => resolve(b));
                    }
                    catch (err) {
                        reject(err);
                    }
                });
                const url = URL.createObjectURL(blob);
                taskManager.service.completeFastExportTask(taskId, url, fileName);
            }
            catch (_err) {
                taskManager.service.failFastExportTask(taskId, undefined, (0, i18n_1.Translate)(i18n_1.T.ERROR_GENERAL));
            }
        });
    }
    // ── Legacy export mode (no new-export-ui token) ──
    /**
     * Legacy export orchestration: blocks the UI with a spinner on the export button,
     * waits for the task to complete, then auto-downloads or shows notification modal.
     */
    runExportLegacy(func) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.exporting = true;
            const taskManager = (0, long_running_task_manager_1.getLongRunningTaskManager)();
            taskManager.state.pendingExports++;
            try {
                const taskId = yield export_menu_ctrl_1.ExportMenuController.runExport(func);
                if (!taskId)
                    return;
                const task = yield taskManager.service.awaitTaskCompletion(taskId);
                // Mark as fully handled since legacy mode auto-handles everything
                const taskUpdate = { seen: true, actioned: true, notified: true };
                taskManager.state.updateTask(task.taskId, taskUpdate);
                if (task.status === core_api_1.LongRunningTaskStatus.COMPLETED) {
                    taskManager.service.downloadTask(task.taskId);
                }
                else if (task.status === core_api_1.LongRunningTaskStatus.FAILED) {
                    notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_EXPORT });
                }
                else {
                    // COMPLETED_WARNINGS or COMPLETED_ERRORS — show notification modal
                    yield taskManager.service.showNotificationModal(task.taskId);
                }
            }
            catch (_) {
                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
            }
            finally {
                taskManager.state.pendingExports--;
                this.exporting = false;
            }
        });
    }
    /**
     * Legacy PDF export: shows a modal with spinner, auto-downloads on completion.
     * Matches the old production behavior from before the download manager UI.
     */
    legacyExportPDF(type, reportNameTranslationKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const taskManager = (0, long_running_task_manager_1.getLongRunningTaskManager)();
            taskManager.state.pendingExports++;
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_TITLE),
                content: (0, mithril_1.m)('div', {}, [
                    (0, mithril_1.m)('div', { style: { marginBottom: theme_1.DefaultTheme.space(2) } }, (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_CONTENT)),
                    spinner_1.Spinner.view(),
                ]),
                hasCancel: false,
            });
            try {
                const result = yield index_1.Services.Department.rest.Department.User.isLicensed(null);
                if (result.results) {
                    (yield export_menu_ctrl_1.ExportMenuController.exportReport(type)).download(`${(0, i18n_1.Translate)(reportNameTranslationKey)} ${new Date().toDateString()}`, () => {
                        taskManager.state.pendingExports--;
                        modal_service_1.ModalService.close();
                    });
                }
                else {
                    index_1.Services.License.hasNoLicense = true;
                    taskManager.state.pendingExports--;
                    modal_service_1.ModalService.close();
                }
            }
            catch (_err) {
                taskManager.state.pendingExports--;
                modal_service_1.ModalService.close();
                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
            }
        });
    }
}
exports.ExportMenu = ExportMenu;
tslib_1.__decorate([
    mobx_1.observable
], ExportMenu.prototype, "exporting", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], ExportMenu.prototype, "runExportLegacy", null);
//# sourceMappingURL=export.menu.js.map